<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p><a id="fm1">
<div class="fmhT">Also by Tom Holt</div>
<div class="ctag1"><em>Expecting Someone Taller <br/>Who’s Afraid of Beowulf? <br/>Flying Dutch <br/>Ye Gods! <br/>Overtime <br/>Here Comes the Sun <br/>Grailblazers <br/>Faust Among Equals <br/>Odds and Gods <br/>Djinn Rummy <br/>My Hero <br/>Paint Your Dragon <br/>Open Sesame <br/>Wish You Were Here <br/>Only Human <br/>Snow White and the Seven Samurai <br/>Valhalla <br/>Nothing But Blue Skies <br/>Falling Sideways <br/>Little People <br/>The Portable Door <br/>In Your Dreams <br/>Earth, Air, Fire and Custard <br/>You Don’t Have to be Evil to Work Here, But It Helps <br/>Barking <br/>The Better Mousetrap <br/>May Contain Traces of Magic <br/>Blonde Bombshell <br/>Life, Liberty, and the Pursuit of Sausages <br/>Doughnut</em></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tomh_9780748113576_oeb_fm1_r1.vue?1f8cbce4